document.addEventListener('DOMContentLoaded', () => {
    const toggleButtons = document.querySelectorAll('.app-faqs.app-faqs-custom .collapsible-content__toggle');
    const answerContents = document.querySelectorAll('.app-faqs.app-faqs-custom .collapsible-content__answer');
    const customFaq = document.querySelector('.app-faqs.app-faqs-custom');
    if (!customFaq) return;
        
        const firstFaq = customFaq.querySelector('.collapsible-content__item');
        const firstAnswer = customFaq.querySelector('.collapsible-content__answer');
        const arrowUp = customFaq.querySelector('.arrow-up');
        const arrowDown = customFaq.querySelector('.arrow-down');

        if (firstFaq && firstAnswer) {
            firstFaq.classList.add('active');
            firstAnswer.classList.add('active');
            firstAnswer.style.display = 'block';
            arrowUp.style.display = 'block';
            arrowDown.style.display = 'none';
        }

    toggleButtons.forEach((toggleButton, index) => {
        toggleButton.addEventListener('click', () => {
            answerContents.forEach((answerContent, i) => {
                if (i === index) {
                    return;
                }
                answerContent.classList.remove('active');

                toggleButtons[i]
                    .closest('.collapsible-content__item')
                    .classList.remove('active');

                toggleButtons[i].querySelector('.arrow-down').style.display = 'block';
                toggleButtons[i].querySelector('.arrow-up').style.display = 'none';
            });

            answerContents[index].classList.toggle('active');

                const downIcon = toggleButton.querySelector('.arrow-down');
                const upIcon = toggleButton.querySelector('.arrow-up');

                downIcon.style.display = answerContents[index].classList.contains('active') ? 'none' : 'block';
                upIcon.style.display = answerContents[index].classList.contains('active') ? 'block' : 'none';
        });
    });
});